import { useTryCallApi } from 'common/hooks/use-try-call-api'
import { AiAgentSettingsService, PresenterAIAgentSettingResponse } from 'common/open-api'
import { useEffect } from 'react'

/**
 * Fetches the current office's AI agent setting status via `AiAgentSettings.aiAgentList`
 * (GET /settings/ai-agent) and exposes the toggle/consent flags.
 */
export const useAIAgentSettingStatus = () => {
  const { data, callApi } = useTryCallApi(AiAgentSettingsService.aiAgentList)

  useEffect(() => {
    callApi()
  }, [callApi])

  return {
    aiAgentSettingEnabled: (data?.data as PresenterAIAgentSettingResponse)?.enabled ?? false,
  }
}
